// TODO: We should move to use the qs library. Delete this once all usages have been removed
export const getParameterString = parameters =>
  Object.keys(parameters)
    .filter(key => parameters[key] !== null && typeof parameters[key] !== 'undefined')
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(parameters[key])}`)
    .join('&')
